/**
 * Tailwind classes applied to the Mantine v7 calendar (Styles API selectors).
 * Mantine v7 no longer supports emotion `styles` with nested selectors (`&:hover`),
 * hence classNames + data-attributes variants (`data-selected`, `data-in-range`...).
 * `text-sm/[1.5]`, `rounded`, `mb-*`, `pb-*`: Tailwind's preflight (`button { font: inherit; border-radius: 0 }`, `* { margin: 0; padding: 0 }`, `base` layer)
 * beats Mantine's font-size, border-radius, margins and paddings (`vendor` layer), so the pre-v7 values (14px / 1.5, 4px) are restored explicitly.
 */
export const calendarCardClassNames = {
  levelsGroup: 'rounded-2xl border border-neutral-10 shadow-elevation-3 bg-white p-4',
};

export const calendarClassNames = {
  calendarHeader: 'mb-2.5',
  calendarHeaderControl: 'rounded hover:bg-neutral-10 text-neutral-140',
  calendarHeaderLevel: 'rounded text-sm/[1.5] text-neutral-140 hover:bg-neutral-10',
  yearsListControl:
    'rounded-lg text-sm/[1.5] text-neutral-140 hover:bg-neutral-10 data-selected:bg-primary-100 data-selected:text-white data-selected:hover:bg-primary-110',
  monthsListControl:
    'rounded-lg text-sm/[1.5] text-neutral-140 hover:bg-primary-20 data-selected:bg-primary-100 data-selected:text-white data-selected:hover:bg-primary-110',
  weekday: 'pb-1.5 text-neutral-60',
  day: 'not-data-in-range:rounded text-sm/[1.5] text-neutral-140 hover:bg-primary-20 data-outside:text-neutral-60 data-in-range:bg-primary-10 data-first-in-range:rounded-l-lg data-last-in-range:rounded-r-lg data-selected:bg-primary-100 data-selected:text-white data-selected:hover:bg-primary-110',
};

/** Concatenates, per Styles API selector, the Jxt default classes with the ones given by the caller. */
export const mergeClassNames = <T extends string>(
  base: Partial<Record<T, string>>,
  extra?: Partial<Record<T, string>>
) => {
  const merged: Partial<Record<T, string>> = { ...base };
  (Object.keys(extra ?? {}) as T[]).forEach((key) => {
    merged[key] = [base[key], extra?.[key]].filter(Boolean).join(' ');
  });
  return merged;
};
